import {
  formatarDataBR,
  hojeEmBrasilia,
  idadeGestacional,
  ROTULO_STATUS_GESTACAO,
  STATUS_EM_ANDAMENTO,
} from '@metaepi/shared';
import type { TipoStatus } from '../../components/ui';
import type { Gestacao } from './api';

export const dataBR = (data: string | null | undefined) => (data ? formatarDataBR(data) : '—');

const NO_BRASIL = { timeZone: 'America/Sao_Paulo' } as const;
const formatoData = new Intl.DateTimeFormat('pt-BR', { ...NO_BRASIL, dateStyle: 'short' });
const formatoHora = new Intl.DateTimeFormat('pt-BR', { ...NO_BRASIL, timeStyle: 'short' });

/**
 * Data de um INSTANTE gravado pela API (ex.: "2026-10-16T01:55:00Z") no horário de Brasília.
 * Cortar a string pegaria o dia em UTC: às 22h55 de 15/10 em Brasília, já é 16/10 em UTC.
 */
export const dataDoInstante = (instante: string | null | undefined) =>
  instante ? formatoData.format(new Date(instante)) : '—';

/** "15/10/2026 22:55" no horário de Brasília. */
export const dataHoraDoInstante = (instante: string | null | undefined) =>
  instante
    ? `${formatoData.format(new Date(instante))} ${formatoHora.format(new Date(instante))}`
    : '—';

/** Idade em anos completos na data de hoje (Brasília). */
export function idadeEmAnos(nascimento: string): number {
  const hoje = hojeEmBrasilia();
  const anos = Number(hoje.slice(0, 4)) - Number(nascimento.slice(0, 4));
  return hoje.slice(5) < nascimento.slice(5) ? anos - 1 : anos;
}

/** "12 semanas e 3 dias" pela DUM, na data de hoje. */
export function igHoje(dum: string | null | undefined): string | null {
  if (!dum) return null;
  const hoje = hojeEmBrasilia();
  if (dum > hoje) return null;
  const { semanas, dias } = idadeGestacional(dum, hoje);
  return `${semanas} semana${semanas === 1 ? '' : 's'}${dias ? ` e ${dias} dia${dias === 1 ? '' : 's'}` : ''}`;
}

export const emAndamento = (g: Pick<Gestacao, 'status'>) =>
  (STATUS_EM_ANDAMENTO as readonly string[]).includes(g.status);

export function seloGestacao(status: Gestacao['status']): { tipo: TipoStatus; texto: string } {
  const texto = ROTULO_STATUS_GESTACAO[status];
  if (status === 'cancelada') return { tipo: 'neutro', texto };
  if (status === 'finalizada' || status === 'parto_realizado') return { tipo: 'sucesso', texto };
  return { tipo: 'info', texto };
}
